:root {
  color-scheme: dark;
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
  font-synthesis: none;
  --ink: #090b0f;
  --ink-raised: #11141b;
  --ink-soft: #1a1f28;
  --pearl: #f4f0e8;
  --silver: #b8bec8;
  --silver-dim: #7e8795;
  --coral: #ff4f5f;
  --coral-bright: #ff6f67;
  --cyan: #7ce8eb;
  --gold: #d9be83;
  --good: #64d6a0;
  --warning: #ffc66b;
  --danger: #ff6b7a;
  --line: rgba(244, 240, 232, 0.12);
  --line-strong: rgba(244, 240, 232, 0.24);
  --glass: rgba(17, 20, 27, 0.84);
  --shadow: 0 24px 80px rgba(0, 0, 0, 0.46);
  --radius-sm: 10px;
  --radius-md: 16px;
  --radius-lg: 24px;
  --radius-pill: 999px;
  --ease-out: cubic-bezier(0.2, 0.8, 0.2, 1);
}

* { box-sizing: border-box; }
html { background: var(--ink); }
body { margin: 0; min-width: 320px; min-height: 100vh; background: var(--ink); color: var(--pearl); }
button, input, textarea, select { font: inherit; }
button, a { -webkit-tap-highlight-color: transparent; }
button { color: inherit; }
a { color: inherit; text-decoration: none; }
img { display: block; max-width: 100%; }

.k-button {
  min-height: 44px;
  border: 1px solid transparent;
  border-radius: var(--radius-pill);
  padding: 0 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: var(--pearl);
  color: var(--ink);
  font-weight: 720;
  letter-spacing: .02em;
  cursor: pointer;
  transition: transform .18s var(--ease-out), background .18s, opacity .18s;
}
.k-button:hover { transform: translateY(-1px); }
.k-button:active { transform: scale(.98); }
.k-button:disabled { opacity: .42; cursor: not-allowed; transform: none; }
.k-button--accent { background: var(--coral); color: white; }
.k-button--ghost { background: transparent; color: var(--pearl); border-color: var(--line-strong); }

.k-badge {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 2px 9px;
  border: 1px solid var(--line);
  border-radius: var(--radius-pill);
  color: var(--silver);
  background: rgba(255,255,255,.04);
  font-size: 12px;
  font-weight: 680;
}

.k-empty { min-height: 240px; display: grid; place-items: center; align-content: center; text-align: center; padding: 32px; color: var(--silver); }
.k-empty strong { color: var(--pearl); font-family: "Songti SC", "STSong", Georgia, serif; font-size: 22px; }
.k-empty p { max-width: 340px; line-height: 1.7; }
.k-empty__icon { margin-bottom: 12px; color: var(--coral); }

.k-skeleton { display: block; min-height: 16px; border-radius: 8px; background: linear-gradient(90deg, #171b23 25%, #242a34 50%, #171b23 75%); background-size: 200% 100%; animation: k-shimmer 1.3s infinite; }
.k-visually-hidden { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0,0,0,0); white-space: nowrap; border: 0; }

@keyframes k-shimmer { to { background-position: -200% 0; } }

:focus-visible { outline: 2px solid var(--cyan); outline-offset: 3px; }

@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after { animation-duration: .01ms !important; animation-iteration-count: 1 !important; scroll-behavior: auto !important; transition-duration: .01ms !important; }
}
